export { default as ProductTableList } from './ProductTableList'
